import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, FsCatalog, TextInput } from '../types'
import { CmsConverterService, defaultFSCatalog, defaultTextInput } from '../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class RelatedProductsAndFamiliesListConverter extends CmsConverterService<RelatedProductsAndFamiliesListData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      headline: formData.st_headline ?? defaultTextInput,
      bgGrey: formData.st_backgroundcolor?.value ?? false,
      productIds: formData.st_product_ids ?? defaultFSCatalog
    }
  }
}

export const RELATED_PRODUCTS_AND_FAMILIES_LIST_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, RelatedProductsAndFamiliesListData>>('RelatedProductsAndFamiliesListConverter')

export interface RelatedProductsAndFamiliesListData extends ConvertedComponentData {
  headline: TextInput;
  bgGrey: boolean;
  productIds: FsCatalog<string>;
}
